/* Repair stale Swym display metadata from the current public Shopify catalogue.
   Read-only: saved list contents, consent, prices and availability are untouched. */
(() => {
  'use strict';
  function selectProduct(products, identity) {
    const id = String(identity.id || ''), variant = String(identity.variantId || '');
    return products.find(p => id ? String(p.id) === id : variant && (p.variant_ids || []).some(v => String(v) === variant));
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {selectProduct}; return; }
  const watched = new WeakMap();
  async function resolve(identity) {
    if (!window.BWRelatedSearch || (!identity.id && !identity.variantId)) return null;
    const product = selectProduct((await window.BWRelatedSearch.loadIndex()).products, identity);
    if (!product || !product.image || !product.handle) return null;
    const image = new URL(product.image, location.origin);
    if (image.protocol !== 'https:' || !(image.hostname === location.hostname || image.hostname === 'cdn.shopify.com')) return null;
    const href = (window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(product.handle);
    return {image:image.href, href, title:product.title};
  }
  function watch(img, identity, onResolved, reset) {
    const key = String(identity.id || identity.variantId || '');
    if (!key || (!reset && watched.get(img)?.key === key)) return;
    const state = {key, attempted:false}; watched.set(img,state);
    const repair = async () => {
      if (state.attempted || watched.get(img) !== state) return;
      state.attempted = true;
      try {
        const result = await resolve(identity);
        if (!result || !img.isConnected || watched.get(img) !== state) return;
        img.removeAttribute('srcset'); img.src = result.image; img.hidden = false;
        img.alt = result.title || img.alt;
        if (onResolved) onResolved(result);
      } catch (_) { /* A catalogue outage must not interfere with wishlist actions. */ }
    };
    img.addEventListener('error',repair,{once:true});
    if (!img.getAttribute('src') || (img.complete && !img.naturalWidth)) repair();
  }
  window.BWWishlistImages = {watch};
})();
